import React from 'react';
import HomeThreeMain from './HomeThreeMain';
import HeaderThree from '../../components/Header/HeaderThree';
import FooterTwo from '../../components/Footer/FooterTwo';

const HomeThree = () => {
  return (
    <>
      <HeaderThree />

      <HomeThreeMain />

      <FooterTwo />
    </>
  );
};

export default HomeThree;
